import { Routes } from '@angular/router';
import { GoldschmiedeComponent } from './pages/goldschmiede.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { KopfauComponent } from './pages/kopfau/kopfau.component';

export const goldschmiedeRoutes: Routes = [
  { path: 'goldschmiede',
    children: [
      {
        path: '',
        component: GoldschmiedeComponent,
        children: [{
          path: '',
          component: DashboardComponent
        }]
      },
      {
        path: ':id',
        component: KopfauComponent
      }
    ],
  },
  // {
  //   path: ':id',
  //   component: KopfauComponent,
  // },
  // {
  //   path: '',
  //   component: DashboardComponent,
  //   pathMatch: 'full'
  // },
  /*{
    path: '**',
    redirectTo: '/'
  }*/
]
